import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { EMAIL_REGEX } from '../../shared/regular-expressions/regex';

export function getUserForm(selectedRole?: string): FormGroup {
  return new FormGroup({
    // email
    identifier: new FormArray([
      new FormGroup({
        value: new FormControl(null, Validators.pattern(EMAIL_REGEX))
      })
    ]),
    // role
    code: new FormArray([
      new FormGroup({
        coding: new FormArray([
          new FormGroup({
            code: new FormControl(selectedRole),
            display: new FormControl()
          })
        ])
      })
    ]),
    password: new FormControl()
  });
}

@Component({
  selector: 'inc-se-user-modal',
  templateUrl: './se-user-modal.component.html',
  styleUrls: ['./se-user-modal.component.scss'],
})
export class SeUserModalComponent implements OnInit {
  @Input() title = 'ADD_USER';
  @Input() form: FormGroup;
  @Input() roles: string[] = ['user', 'manager'];
  @Input() selectedRole = 'user';

  constructor(private modalController: ModalController) { }

  ngOnInit() {
    this.form = getUserForm(this.selectedRole);
  }

  close(data?) {
    this.modalController.dismiss(data);
  }
}
